import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Link } from "../link";
import classNames from "classnames";

const AccessoriesAndConsumablesBannerMenu = ({ acBanner, className }) => {
  return (
    <div
      className={classNames(
        "row d-lg-flex flex-lg-row new-navigation__accessory-container",
        className
      )}
    >
      <div className="col-lg-5 d-flex flex-column new-navigation__accessory-wrapper">
        {((!!acBanner?.useCustomName && acBanner?.name) || acBanner?.content?.newTitle) && (
          <div className="new-navigation__accessory-title">
            {!!acBanner?.useCustomName && acBanner?.name
              ? acBanner.name
              : acBanner?.content?.newTitle}
          </div>
        )}
        {((!!acBanner?.useCustomName && acBanner?.name) || acBanner?.content?.newTitle) && (
          <div className="new-navigation__accessory-bar"></div>
        )}
        {acBanner?.content?.cta?.length > 0 &&
          acBanner?.content.cta.map((item, i) =>
            item?.label ? (
              <div key={i} className="new-navigation__accessory-item">
                {item?.slug ? (
                  <Link
                    to={item.slug}
                    target={item?.target && item?.target?.length > 0 ? item.target?.[0] : ""}
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span>
                    {!!item?.useCustomName && item?.name ? item.name : item?.content?.title}
                  </span>
                )}
              </div>
            ) : null
          )}
      </div>
      <div className="col-lg-7 d-none d-lg-block new-navigation__accessory-image">
        {acBanner?.content?.image?.node && (
          <GatsbyImage
            image={getImage(acBanner?.content.image.node)}
            alt={acBanner?.content?.image?.value?.description || ""}
          />
        )}
      </div>
    </div>
  );
};

export default AccessoriesAndConsumablesBannerMenu;
